import type { ReactNode } from 'react';
import * as Popover from '@radix-ui/react-popover';
import { INFO_EXPLAIN_SCRIM_CLASS } from './infoExplainPopoverChrome.js';

export type InfoExplainPopoverPortalProps = {
  readonly children: ReactNode;
  /** Scrim `data-testid` (panel test ids stay on Content). */
  readonly scrimTestId?: string;
};

/**
 * Portal + dismiss scrim for explain popovers — one stacking family with
 * MetricExplainButton / AnalyticsPanelInfoButton / EventMeasureHelpIcon.
 */
export function InfoExplainPopoverPortal({
  children,
  scrimTestId,
}: InfoExplainPopoverPortalProps): JSX.Element {
  return (
    <Popover.Portal>
      <>
        <div
          aria-hidden
          data-testid={scrimTestId}
          className={INFO_EXPLAIN_SCRIM_CLASS}
        />
        {children}
      </>
    </Popover.Portal>
  );
}